
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/contents/[postId]",
      function () {
        return require("private-next-pages/festivals/[festivalId]/contents/[postId].tsx");
      }
    ]);
  